import { configureStore } from "@reduxjs/toolkit";
import userPermitionSlice from "./slices/UserPermitionSlice";
import userSlice from "./slices/userSlice";
import MasterSlice from "./slices/MasterSlice";
const store = configureStore({
    reducer: {
        user: userSlice,
        userPermitionSlice: userPermitionSlice,
        MasterSlice:MasterSlice,
    },
});

export default store;
